import React from 'react'
import SelectAsync from 'react-select/async'
import {observer} from 'mobx-react'

const ReviewSelectAsyncInput = observer(({store, placeholder, inputId, onSelected}) => {
  const handleChange = (option) => {
    store.handleChange(option)
    const value = option ? (Array.isArray(option) ? option[0]?.value : option.value) : ''
    onSelected?.(value || '')
  }

  const handleBlur = () => {
    store.handleBlur()
    const currentValue = store.value || ''
    onSelected?.(currentValue)
  }

  return (
    <div ref={store.selectWrapperRef}>
      <SelectAsync
        className="reviewpopup-Form_selectSuggestInput"
        inputId={inputId}
        name={store.name}
        value={store.selectedOption}
        onChange={handleChange}
        onBlur={handleBlur}
        onInputChange={store.handleInputChange}
        onMenuOpen={store.handleMenuOpen}
        onMenuClose={store.handleMenuClose}
        onFocus={store.handleFocus}
        loadOptions={store.loadOptions}
        cacheOptions={false}
        filterOption={null}
        isClearable={true}
        placeholder={placeholder}
        loadingMessage={() => "検索中です……"}
        noOptionsMessage={({ inputValue }) => inputValue ? "該当する地域が見つかりません" : "地域名を入力してリストから選んでください"}
      />
    </div>
  )
})

export default ReviewSelectAsyncInput
